import React from "react";
import ProductTemplate from "../../ProductTemplate";
import w77Cover from "../../../assets/w77/W77Cover.png";
import w77a from "../../../assets/w77/w77a.webp";
import w77b from "../../../assets/w77/w77b.webp";
import w771 from "../../../assets/w77/w771.webp";
import w772 from "../../../assets/w77/w772.webp";
import w773 from "../../../assets/w77/w773.webp";
import w774 from "../../../assets/w77/w774.webp";
import w775 from "../../../assets/w77/w775.webp";
import w77sec1 from "../../../assets/w77/w77sec1.webp";
import w77sec2 from "../../../assets/w77/w77sec2.jpg";

const W77 = () => {
  const data = {
    title: "ULTRASLIM 77",
    subtitle: "Hinged insulated ultra slim system",
    description:
      "The SMARTIA W77 is a modern, robust, and thermally insulated hinged system that offers high energy efficiency, sound insulation, and security. It is ideal for residential and commercial projects requiring advanced performance and aesthetics.",
    specifications: [
      { label: "WINDOW TYPE", value: "Hinged" },
      { label: "FRAME DEPTH", value: "77 mm" },
      { label: "U-VALUE", value: "from 0.85 to 2.42 W/m²K" },
      { label: "BURGLAR RESISTANCE", value: "RC2/RC3" },
      { label: "WATER TIGHTNESS", value: "CLASS E1350" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "up to 72 mm" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE HEIGHT", value: "93 mm" },
    ],
    renders: [w77Cover, w77a, w77b],
    typologies: [
      { image: w771, caption: "Single hinged window" },
      { image: w772, caption: "Double hinged window" },
      { image: w773, caption: "Hinged window with fixed light" },
      { image: w774, caption: "Tilt-and-turn window" },
      { image: w775, caption: "Hinged door with fixed light" },
    ],
    sections: [w77sec1, w77sec2],
    relatedFiles: [
      {
        label: "W77 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/smartia/pre-qualification-w77.pdf",
      },
      {
        label: "W77 Brochure",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/smartia/w77_en.pdf",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default W77;